import styled from "styled-components";

export const UploadedFilesContainer = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .uploaded-file-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
  }

  .file-name {
    flex: 1;
    font-size: 12px;
    border: 1px solid var(--color-gray-200, #e5e5e5);
    border-radius: 8px;
    display: flex;
    margin: 0;
    padding: 6px 12px;
  }

  .delete-file-button {
    width: 32px;
    height: 32px;

    i {
      width: 18px;
      height: 18px;
    }
  }
`;
